import {
  Root,
  Home,
  Product,
  ProductDetail,
  Service,
  TipsTrends,
  TipsTrendsDetail,
  About,
  Faq,
  Contact
} from "../pages";

export default [
  {
    component: Root,
    routes: [
      { path: "/", exact: true, component: Home },
      { path: "/product", exact: true, component: Product },
      { path: "/product/detail/:id", exact: true, component: ProductDetail },
      { path: "/service", exact: true, component: Service },
      { path: "/tips-trends", exact: true, component: TipsTrends },
      { path: "/tips-trends/detail/:id", exact: true, component: TipsTrendsDetail },
      { path: "/about", exact: true, component: About },
      { path: "/faq", exact: true, component: Faq },
      { path: "/contact", exact: true, component: Contact },
      { component: Home }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/config/routes.js